import { intersection } from 'lodash';

export const getSwitcherTitle = ({
    raceTypeCode: { 0: code },
}) => {
    switch (code) {
        case 'F':
        case 'W':
        case 'X':
            return 'Flat';
        case 'H':
            return 'Hurdle';
        case 'U':
        case 'C':
            return 'Chase';
        default:
            return '';
    }
};

export const getDescription = ({
    raceTypeCode, rpDetailedAwDesc, rpDetailedFlatDesc, rpDetailedJumpDesc,
}) => {
    if (intersection(raceTypeCode, ['W', 'X', 'Y', 'Z']).length) {
        return rpDetailedAwDesc;
    } else if (raceTypeCode.includes('F')) {
        return rpDetailedFlatDesc;
    } else if (intersection(raceTypeCode, ['U', 'C', 'P', 'H', 'B']).length) {
        return rpDetailedJumpDesc;
    }
    return '';
};




// WEBPACK FOOTER //
// ./src/js/course/courseMap/helpers.js